<template lang="pug">
.study-result-detail-list
  //- ヘッダー部
  .study-result-detail-list__header
    button-return.study-result-detail-list__header__button(@click='moveReturnEvent')
      slot(name='returnButtonText')
    text-frame.study-result-detail-list__header__title.text-large
      .study-result-detail-list__header__title__value {{ resultDetailTitle }}
      .study-result-detail-list__header__title__label
        slot(name='titleLabel')
  //- 得点情報一覧表示
  study-result-detail-score-table.study-result-detail-list__list(
    v-if='studyResultDetailScore',
    :studyResultDetailScore='studyResultDetailScore',
  )
    template(#totalScoreHeader)
      slot(name='totalScoreHeader')
    template(#knowledgeScoreHeader)
      slot(name='knowledgeScoreHeader')
    template(#thinkingScoreHeader)
      slot(name='thinkingScoreHeader')
    template(#scoreLabel)
      slot(name='scoreLabel')
    template(#averageLabel)
      slot(name='averageLabel')
  //- 解説動画ボタン
  .study-result-detail-list__action
    button-primary.study-result-detail-list__action__button(@click='movieButtonEvent', v-if='showMovieButton')
      slot(name='movieButtonText')
  //- 一覧表示
  study-result-detail-table.study-result-detail-list__list(:studyResultDetails='studyResultDetails')
    template(#problemNumberHeader)
      slot(name='tableProblemNumberHeader')
    template(#questionNumberHeader)
      slot(name='tableQuestionNumberHeader')
    template(#correctSymbolHeader)
      slot(name='tableCorrectSymbolHeader')
    template(#correctRateHeader)
      slot(name='tableCorrectRateHeader')
  //- アドバイスメッセージ
  text-frame.study-result-detail-list__advice
    .study-result-detail-list__advice__title.font-bold
      slot(name='studyAdviceTitle')
    .study-result-detail-list__advice__message.text-small(v-html='studyAdviceMessage')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonReturn from '@/components/molecules/student/ButtonReturn.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'
import StudyResultDetailScoreTable from '@/components/organisms/student/StudyResultDetailScoreTable.vue'
import StudyResultDetailTable from '@/components/organisms/student/StudyResultDetailTable.vue'
import { StudyResultDetailType, StudyResultDetailScore } from '@/models/studyResultDetailModel'

/**
 * テスト結果詳細画面テンプレート
 */
@Component({
  components: {
    ButtonReturn,
    TextFrame,
    ButtonPrimary,
    StudyResultDetailScoreTable,
    StudyResultDetailTable,
  },
})
export default class StudyResultDetailList extends Vue {
  // 戻るボタン押下時イベント
  @Prop()
  moveReturnEvent!: Function

  // 画面タイトル
  @Prop()
  resultDetailTitle!: string

  // テスト結果詳細得点情報
  @Prop()
  studyResultDetailScore!: StudyResultDetailScore

  // 解説動画を見るボタン押下時イベント
  @Prop()
  movieButtonEvent!: Function

  // 解説動画を見るボタン表示フラグ
  @Prop()
  showMovieButton!: boolean

  // テスト結果詳細表示情報
  @Prop()
  studyResultDetails!: StudyResultDetailType[]

  // 学習アドバイスメッセージ
  @Prop()
  studyAdviceMessage!: string
}
</script>

<style lang="stylus" scoped>
.study-result-detail-list
  margin 0 20px
  padding 20px 0

  &__header
    display flex
    align-items center
    margin-bottom 10px

    &__button
      width 180px
      margin-right 10px

    &__title
      width 100%
      display flex
      justify-content center
      padding 20px
      background-color var(--color-default__box-background)

      &__label
        margin-left 5px

  &__list
    margin-bottom 10px

  &__action
    display flex
    justify-content center
    padding 10px
    margin-bottom 10px

    &__button
      width 180px

  &__advice
    width 100%
    background-color var(--color-default__box-background)
    border 2px solid var(--color-default__border)
    border-radius 10px
    padding 10px
    margin 10px 0 20px 0

    &__title
      color var(--color-study-list-annotation__text)

    &__message
      padding 10px 40px
      white-space break-spaces
</style>
